import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import ClosestReview from './components/ClosestReview'
import Chip from './components/Chip'
// themes
import { colors } from 'themes'
// types
import { IPlan } from 'types/graphql'
// utils
import get from 'lodash/get'
import { getOwnedBy } from 'utils/tables'
import { truncate } from 'utils/string'

// styled
const Wrapper = styled.div`
  padding-right: 4px;

  > p {
    font-size: 20px;
    font-weight: 500;
    margin: 8px 0 8px 0;
  }
`

const InnerWrapper = styled.div`
  background-color: ${colors.gray190};
  padding: 16px;

  > div {
    margin-bottom: 16px;
  }

  .label {
    color: ${colors.gray350};
    font-size: 12px;
  }

  .value {
    color: ${colors.gray450};
    font-size: 16px;
  }

  .members {
    display: flex;
    flex-wrap: wrap;
  }
`

const Title = styled.p`
  padding-left: 16px;
`

const Header = styled.div`
  align-items: center;
  background: ${colors.darkBlue500};
  color: ${colors.white100};
  display: flex;
  font-size: 22px;
  font-weight: bold;
  height: 64px;
  padding: 0 16px;
  position: relative;

  > div {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }
`

// types
interface IIncomingProps {
  plan: IPlan | any
}

const PlanDetails: React.FC<IIncomingProps> = ({ plan }) => {
  const ownedBy: string = getOwnedBy(
    get(plan, 'ownedByPosition.description'),
    get(plan, 'ownedByPosition.user') || plan.ownedByUser
  )

  return (
    <Wrapper>
      <Header>
        <div>{truncate(plan.name, 80)}</div>
      </Header>

      <ClosestReview plan={plan} />
      <Title>About this plan</Title>
      <InnerWrapper>
        <div>
          <div className='label'>{plan.planType.description}</div>
          <div className='value'>{plan.name}</div>
        </div>
        <div>
          <div className='label'>Owned By</div>
          <div className='value'>{ownedBy ? ownedBy : 'N/A'}</div>
        </div>
        <div>
          <div className='label'>Members (User, Position)</div>
          <div className='value members'>
            {get(plan, 'membersUserPosition.length')
              ? plan.membersUserPosition.map(member => <Chip label={member.label} key={member.label} />)
              : 'N/A'}
          </div>
        </div>
        <div>
          <div className='label'>Status</div>
          <div className='value'>{plan.status ? plan.status.label : 'N/A'}</div>
        </div>
      </InnerWrapper>
      <p className='html2pdf-page-break'>Plan view</p>
    </Wrapper>
  )
}

export default PlanDetails
